export const typography = {
	typography: {
		fontFamily: [
			'Rubik',
			'-apple-system',
			'BlinkMacSystemFont',
			'"Segoe UI"',
			'Roboto',
			'"Helvetica Neue"',
			'Arial',
			'sans-serif',
			'"Apple Color Emoji"',
			'"Segoe UI Emoji"',
			'"Segoe UI Symbol"',
		].join(','),
		h4: {
			fontSize: 24,
			color: '#1d1d1d',
		},
		subtitle2: {
			color: '#707070',
			fontSize: 16,
		},
		body2: {
			fontSize: 14,
		},
		body1: {
			fontSize: 16,
		},
	},
};
